import {
  ArrayField,
  Datagrid,
  FunctionField,
  ReferenceField,
  TextField,
  useRecordContext,
} from "react-admin";
import { Box, Button } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import { settings } from "app";
import { doctoralRequests } from "api/doctoralApi";
import RemoveSeatDialog from "./RemoveSeatDialog";
import ExamAdmissionCommitteeDialog from "./ExamAdmissionCommitteeDialog";

const ConspectLink = ({ url }) => {
  if (!url) return null;
  return (
    <Button
      size="small"
      variant="outlined"
      startIcon={<OpenInNewIcon />}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={e => e.stopPropagation()}
    >
      Отвори
    </Button>
  );
};

const SeatsList = () => {
  const campaign = useRecordContext();
  if (!campaign) return null;

  return (
    <ArrayField source="seats">
      <Datagrid bulkActionButtons={false} rowClick={false} sx={settings.style.secondaryDatagrid}>
        <TextField source="doctoralProgramNameBg" label="Докторантска програма" sortable={false} />
        <ReferenceField
          label="Дисциплина"
          source="doctoralDisciplineId"
          reference={doctoralRequests.getDoctoralDisciplinesSelect()}
          link={false}
          sortable={false}
        >
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField
          label="Форма на обучение"
          source="studyTypeId"
          reference={doctoralRequests.getDoctoralStudyTypesSelect()}
          link={false}
          sortable={false}
        >
          <TextField source="name" />
        </ReferenceField>
        <FunctionField
          label="Конспект (дисциплина)"
          sortable={false}
          render={seat => <ConspectLink url={seat.disciplineConspectLink} />}
        />
        <FunctionField
          label=""
          render={seat => (
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>
              {seat.hasExamAdmissionCommittee ? (
                <>
                  <SecuredComponent permission={permissions.canPreviewDoctoralExamAdmissionCommittees}>
                    <ExamAdmissionCommitteeDialog
                      campaignId={campaign.id}
                      seatId={seat.doctoralSeatId}
                      structuralUnitId={campaign.structuralUnitId}
                      mode="view"
                      triggerLabel="Преглед"
                    />
                  </SecuredComponent>
                  <SecuredComponent permission={permissions.canUpdateDoctoralExamAdmissionCommittees}>
                    <ExamAdmissionCommitteeDialog
                      campaignId={campaign.id}
                      seatId={seat.doctoralSeatId}
                      structuralUnitId={campaign.structuralUnitId}
                      mode="edit"
                      triggerLabel="Редактирай"
                    />
                  </SecuredComponent>
                </>
              ) : (
                <SecuredComponent permission={permissions.canCreateDoctoralExamAdmissionCommittees}>
                  <ExamAdmissionCommitteeDialog
                    campaignId={campaign.id}
                    seatId={seat.doctoralSeatId}
                    structuralUnitId={campaign.structuralUnitId}
                    mode="create"
                    triggerLabel="Създай комисия"
                  />
                </SecuredComponent>
              )}
              <SecuredComponent permission={permissions.canUpdateDoctoralCampaigns}>
                <RemoveSeatDialog campaignId={campaign.id} seatId={seat.doctoralSeatId} />
              </SecuredComponent>
            </Box>
          )}
        />
      </Datagrid>
    </ArrayField>
  );
};

export default SeatsList;
